<template>
  <div>
    <!-- <XVactionbar>
      <template slot="actionbuttons">

      </template>
    </XVactionbar>-->
    <div class="row">
      <div class="col-md-12" v-if="mapsloaded">
        <Nextgooglemaps :markerdata="pointsOfInterest"></Nextgooglemaps>
      </div>
    </div>
  </div>
</template>
      
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

// import { sync } from 'vuex-pathify'
export default {
  data: function () {
    return {}
  },
  async mounted() {
    this.startLoading({ showmessage: false, disablepage: false })
    window.vueGoogleMapsInit = this.SETGooglemapsLoaded
    await this.PEapi_PointsOfInterest(this.$route.params.profgroupID)
    this.stopLoading()
  },
  computed: {
    ...mapGetters('PointsOfInterest', ['pointsOfInterest', 'mapsloaded']),
  },
  methods: {
    ...mapActions('PointsOfInterest', ['PEapi_PointsOfInterest']),
    ...mapMutations('PointsOfInterest', ['SETGooglemapsLoaded']),
  },
}
</script>

<style>
</style>
      
